import { Component, OnDestroy, OnInit } from "@angular/core";
import moment from "moment";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { ManagerLogPostItem } from "src/app/shared/models/ManagerLogPost.item";
import { User } from "src/app/shared/models/user.model";

@Component({
	selector: "app-log-list-view",
	templateUrl: "./log-list-view.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class LogListViewComponent implements OnInit, OnDestroy {
	managerLogPostList: ManagerLogPostItem[];
	managerLogPostFilteredList: ManagerLogPostItem[];
	managerLogPostSelected: ManagerLogPostItem;
	moment: any = moment;

	user: User;

	venueKey: number;
	venueChangeSubscription: Subscription;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		this.init();
	}

	ngOnDestroy() {
		this.venueChangeSubscription.unsubscribe();
	}

	async init() {
		const venue = this.venueService.subscriptionVenue.value;
		this.venueKey = venue.key;
		this.load();
	}

	async load() {
		this.app.loading(true);
		this.user = await this.localStorage.get("user");
		this.managerLogPostGet(this.venueKey);
		this.app.loading(false);
	}

	async managerLogPostGet(venueKey) {
		const resp = await this.focuslink.managerLogGetAll(venueKey);
		this.managerLogPostList = resp.map((i) => {
			const m = new ManagerLogPostItem(i);
			m.created = moment(i.created).toDate();
			m.businessDate = moment(i.businessDate).toDate();
			return m;
		});
		this.managerLogPostFilteredList = this.managerLogPostList;
	}

	deletePost(pk: string, sk: string) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete this post?`,
			accept: async () => {
				const idx = this.managerLogPostList.findIndex((i) => i.sk === sk);
				this.focuslink.managerLogDeleteOne(this.venueKey, sk);
				this.managerLogPostList.splice(idx, 1);
				this.app.msgSvc.add({ severity: "success", detail: "Log Post Deleted." });
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	async newPost() {
		const created = moment();
		this.managerLogPostSelected = new ManagerLogPostItem({
			pk: `LOG_${this.venueKey}`,
			sk: created.valueOf().toString(),
			created: created.format(),
			modified: created.format(),
			authorUserKey: this.user.key,
			tags: [],
			notifications: [],
		});
	}
}
